/**
 * Persistent browser-profile identity used for single-device login enforcement.
 * It is generated automatically and is never shown as a login field.
 */
const DEVICE_ID_KEY = 'deviceId';

const generateDeviceId = (): string => {
    try {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
            return crypto.randomUUID();
        }
    } catch {
        // Fall through to the compatible UUID generator below.
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
        const randomValue = (Math.random() * 16) | 0;
        const value = character === 'x' ? randomValue : (randomValue & 0x3) | 0x8;
        return value.toString(16);
    });
};

export const getDeviceId = (): string => {
    try {
        let deviceId = localStorage.getItem(DEVICE_ID_KEY);
        if (!deviceId) {
            deviceId = generateDeviceId();
            localStorage.setItem(DEVICE_ID_KEY, deviceId);
        }
        return deviceId;
    } catch {
        // Private browsing/storage failures still get a transient session identity.
        return generateDeviceId();
    }
};
